// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"editCreate_formContainer__3SV7v","form":"editCreate_form__1r2TK"};